import React from "react";
import LayoutOne from "../../layouts/LayoutOne";
import { useLanguage } from "../../context/LanguageContext";
import EventRegistration from "../../components/Event/EventRegistration";

const Event = () => {
  const { t } = useLanguage();

  return (
    <LayoutOne>
      <div className="event-page">
        {/* Event Hero Section */}
        <section className="event-hero">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div className="event-hero-content text-center">
                  <h1
                    className="event-title wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    {t("event.title")}
                  </h1>
                  <h2
                    className="event-subtitle wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    {t("event.subtitle")}
                  </h2>
                  <p
                    className="event-main-title wow fadeInUp"
                    data-wow-delay="0.25s"
                  >
                    {t("event.mainTitle")}
                  </p>
                  <div
                    className="event-details wow fadeInUp"
                    data-wow-delay="0.3s"
                  >
                    <div className="event-date">
                      <i className="fas fa-calendar-alt"></i>
                      <span>{t("event.date")}</span>
                    </div>
                    <div className="event-time">
                      <i className="fas fa-clock"></i>
                      <span>{t("event.time")}</span>
                    </div>
                    <div className="event-location">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{t("event.location")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Registration Section */}
        <section className="event-registration">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto">
                <div className="registration-content text-center">
                  <h2 className="wow fadeInUp" data-wow-delay="0.1s">
                    {t("event.registration.title")}
                  </h2>
                  <EventRegistration />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Event Content Section */}
        <section className="event-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div
                  className="event-learn-section wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  <h3>{t("event.learn.title")}</h3>
                  <ul className="learn-list">
                    <li>{t("event.learn.item1")}</li>
                    <li>{t("event.learn.item2")}</li>
                    <li>{t("event.learn.item3")}</li>
                  </ul>
                </div>

                <div
                  className="event-plus-section wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3>{t("event.plus.title")}</h3>
                  <ul className="plus-list">
                    <li>{t("event.plus.item1")}</li>
                    <li>{t("event.plus.item2")}</li>
                    <li>{t("event.plus.item3")}</li>
                  </ul>
                </div>

                <div
                  className="event-guest-section wow fadeInUp"
                  data-wow-delay="0.3s"
                  style={{ marginTop: "20px" }}
                >
                  <h3>{t("event.guest.title")}</h3>
                  <p>{t("event.guest.description")}</p>
                </div>

                <div
                  className="event-why-different wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <h3>{t("event.whyDifferent.title")}</h3>
                  <div className="why-different-content">
                    {t("event.whyDifferent.description")
                      .split("\n\n")
                      .map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))}
                  </div>
                </div>

                <div
                  className="event-why-investors wow fadeInUp"
                  data-wow-delay="0.5s"
                  style={{ marginTop: "40px" }}
                >
                  <h3>{t("event.whyInvestors.title")}</h3>
                  <div className="why-investors-items">
                    {t("event.whyInvestors.items").map((item, index) => (
                      <div key={index} className="investor-item">
                        <h4>
                          {index + 1}. {item.title}
                        </h4>
                        <p>{item.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="event-registration-info wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <p className="registration-note">
                    {t("event.registration.note")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </LayoutOne>
  );
};

export default Event;
